var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wkb-expression-filter",
      class: {
        "wkb-expression-filter--compact": _vm.compact,
        "wkb-expression-filter--has-tissue": _vm.supportsTissue,
      },
    },
    [
      _vm.references.length
        ? _c("label", { staticClass: "wkb-expression-filter-field" }, [
            _c("span", { staticClass: "wkb-expression-filter-label" }, [
              _vm._v("Expression reference"),
            ]),
            _c(
              "select",
              {
                staticClass: "wkb-expression-filter-select",
                domProps: { value: _vm.selectedReferenceId },
                on: { change: _vm.onReferenceChange },
              },
              _vm._l(_vm.references, function (reference) {
                return _c(
                  "option",
                  {
                    key: reference.reference_id,
                    domProps: { value: reference.reference_id },
                  },
                  [_vm._v(" " + _vm._s(reference.label) + " ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm.supportsTissue
        ? _c("label", { staticClass: "wkb-expression-filter-field" }, [
            _c("span", { staticClass: "wkb-expression-filter-label" }, [
              _vm._v("Tissue"),
            ]),
            _vm.useSelectDropdowns && _vm.tissues.length
              ? _c(
                  "select",
                  {
                    staticClass: "wkb-expression-filter-select",
                    domProps: { value: _vm.filters.expressionTissue || "" },
                    on: { change: _vm.onTissueChange },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Select tissue"),
                    ]),
                    _vm._l(_vm.tissues, function (tissue) {
                      return _c(
                        "option",
                        { key: tissue, domProps: { value: tissue } },
                        [_vm._v(" " + _vm._s(tissue) + " ")]
                      )
                    }),
                  ],
                  2
                )
              : _c("input", {
                  staticClass: "wkb-expression-filter-input",
                  attrs: {
                    list: "wkb-expression-filter-tissues",
                    placeholder: "Select tissue",
                  },
                  domProps: { value: _vm.filters.expressionTissue || "" },
                  on: { input: _vm.onTissueInput },
                }),
            !_vm.useSelectDropdowns || !_vm.tissues.length
              ? _c(
                  "datalist",
                  { attrs: { id: "wkb-expression-filter-tissues" } },
                  _vm._l(_vm.tissues, function (tissue) {
                    return _c("option", {
                      key: tissue,
                      domProps: { value: tissue },
                    })
                  }),
                  0
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c("label", { staticClass: "wkb-expression-filter-field" }, [
        _c("span", { staticClass: "wkb-expression-filter-label" }, [
          _vm._v(_vm._s(_vm.cellTypeLabel)),
        ]),
        _vm.useSelectDropdowns
          ? _c(
              "select",
              {
                staticClass: "wkb-expression-filter-select",
                attrs: { disabled: _vm.cellTypeSelectDisabled },
                domProps: { value: _vm.filters.expressionCellType || "" },
                on: { change: _vm.onCellTypeChange },
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.supportsTissue && !_vm.selectedTissue
                          ? "Select tissue first"
                          : "Select cell type"
                      ) +
                      " "
                  ),
                ]),
                _vm._l(_vm.cellTypes, function (cellType) {
                  return _c(
                    "option",
                    { key: cellType, domProps: { value: cellType } },
                    [_vm._v(" " + _vm._s(cellType) + " ")]
                  )
                }),
              ],
              2
            )
          : _c("input", {
              staticClass: "wkb-expression-filter-input",
              attrs: {
                list: "wkb-expression-filter-cell-types",
                placeholder:
                  _vm.supportsTissue && !_vm.selectedTissue
                    ? "Select tissue first"
                    : "Select cell type",
              },
              domProps: { value: _vm.filters.expressionCellType || "" },
              on: { input: _vm.onCellTypeInput },
            }),
        !_vm.useSelectDropdowns
          ? _c(
              "datalist",
              { attrs: { id: "wkb-expression-filter-cell-types" } },
              _vm._l(_vm.cellTypes, function (cellType) {
                return _c("option", {
                  key: cellType,
                  domProps: { value: cellType },
                })
              }),
              0
            )
          : _vm._e(),
      ]),
      _c(
        "label",
        {
          staticClass:
            "wkb-expression-filter-field wkb-expression-filter-field--narrow",
        },
        [
          _c("span", { staticClass: "wkb-expression-filter-label" }, [
            _vm._v("Abs. min"),
          ]),
          _c("input", {
            staticClass: "wkb-expression-filter-input",
            attrs: { type: "number", step: "any", placeholder: "per10k" },
            domProps: { value: _vm.filters.expressionAbsoluteMin || "" },
            on: { input: _vm.onAbsoluteMinInput },
          }),
        ]
      ),
      _c(
        "label",
        {
          staticClass:
            "wkb-expression-filter-field wkb-expression-filter-field--narrow",
        },
        [
          _c("span", { staticClass: "wkb-expression-filter-label" }, [
            _vm._v("Rel. max"),
          ]),
          _c("input", {
            staticClass: "wkb-expression-filter-input",
            attrs: { type: "number", step: "any", placeholder: "p-value" },
            domProps: { value: _vm.filters.expressionRelativeMax || "" },
            on: { input: _vm.onRelativeMaxInput },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }